<template>
  <v-checkbox
    :key="key"
    :input-value="value"
    :indeterminate="isIndeterminate"
    :color="color"
    :disabled="node.disabled || readonly || node.data.is_disabled"
    :style="style"
    style="margin: 0;"
    dense
    hide-details
    class="pa-0 ma-0 BAteTreeFormRecursiveCheckbox"
    @click.native.stop
    @change="$emit('change', node)"
  />
</template>

<script>

const STYLE = { opacity: 0.5 }
const COLOR = '#BDBDBD'

export default {
  name: 'BAteTreeFormRecursiveCheckbox',
  props: {
    readonly: Boolean,
    clearable: Boolean,
    parent_mode: Boolean,
    node: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isIndeterminate() {
      return this.node.isSelected
        ? false
        : this.node.isIndeterminate
    },
    isSelectedParent() {
      return this.parent_mode ? this.node.isSelectedParent : false
    },
    value() {
      return (
        this.node.isSelected
        || this.isIndeterminate
        || this.isSelectedParent
      )
    },
    key() {
      return [
        this.node.isSelected,
        this.isIndeterminate,
        this.isSelectedParent,
      ].join('-')
    },
    style() {
      return this.node.disabled && !this.readonly ? STYLE : void 0
    },
    color() {
      return (this.isIndeterminate || this.isSelectedParent) ? COLOR : void 0
    },
  },
}
</script>
